function u(e, n) {
  return e.type === "submenu" || e.type === void 0 && e[n] !== void 0;
}
function i(e) {
  return e.type === "group";
}
function r(e) {
  return e.type === "divider";
}
function t(e) {
  return e.type === "render";
}
export {
  r as isDividerNode,
  i as isGroupNode,
  t as isRenderNode,
  u as isSubmenuNode
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dropdown/src/utils.js
// module id = 464
// module chunks = 41